export default "__VITE_ASSET__BLlbPbRi__"